import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
//
import { Col, Row, Card, Dropdown, Nav, Tab } from "react-bootstrap";
//
import PageHeader from "../../../components/general/PageHeader";
import SaveHavenDemand from "./SaveHavenDemand";
import LearnMore from "../../../components/general/LearnMore";
import CurrenctFearGreed from "../../../components/fear-greed/CurrenctFearGreed";
import Overtime from "../../../components/fear-greed/Overtime";
import TopFive from "../../../components/alert/TopFive";
import FearGreedQuestion from "./FearGreedQuestion";

//
import Calculator from "../../../assets/img/calculate.png";

function FearGeed({ windowSize }) {
  const [activeTab, setActiveTab] = useState("Save haven Demand");
  let items = [
    {
      name: "Save haven Demand",
      value: "save-haven-demand",
    },
    {
      name: "Junk Bond Demand",
      value: "junk-bond-demand",
    },
    {
      name: "Market Momentum",
      value: "market-momentum",
    },
    {
      name: "Put and Calls Options",
      value: "put-and-calls-options",
    },
    {
      name: "Stock Price Breadth",
      value: "stock-price-breadth",
    },
    {
      name: "Stock Price Strength",
      value: "stock-price-strength",
    },
  ];

  return (
    <div id="fear-greed">
      {/* Start Header */}
      <PageHeader
        title="Fear & Greed Index"
        subject="Crypto details overview and analytics"
      ></PageHeader>
      {/* End Header */}

      <Row>
        <Col xxl={6} className="gutter-b">
          <CurrenctFearGreed />
        </Col>

        <Col sm={6} xxl={3} className="gutter-b">
          <TopFive title="Trending Ticker" type="trending" limit="5" heatmap />
        </Col>

        <Col sm={6} xxl={3} className="gutter-b">
          <LearnMore
            title="How we Calculate the Index?"
            subject="Each day, we analyze emotions and sentiments from different sources and crunch them into one simple number: The Fear & Greed Index for Bitcoin and other large cryptocurrencies."
            src={Calculator}
            modal={<FearGreedQuestion />}
          />
        </Col>
      </Row>

      {/* <Tab.Container defaultActiveKey="save-haven-demand">
        {windowSize > 768 && (
          <div className="tab-header">
            <Nav className="align-items-end">
              {items.map((item, index) => (
                <Nav.Item key={index}>
                  <Nav.Link
                    eventKey={item.value}
                    onClick={() => setActiveTab(item.name)}
                  >
                    {item.name}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
        )}

        <Card className="tabs-box gutter-b">
          {windowSize <= 768 && (
            <Card.Header className="with-dropdown tab-dropdown-header">
              <Dropdown id="tab-dropdown">
                <Dropdown.Toggle>{activeTab}</Dropdown.Toggle>
                <Dropdown.Menu>
                  <Nav>
                    {items.map((item, index) => (
                      <Nav.Item key={index}>
                        <Nav.Link
                          eventKey={item.value}
                          onClick={() => setActiveTab(item.name)}
                        >
                          {item.name}
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </Dropdown.Menu>
              </Dropdown>
            </Card.Header>
          )}

          <Card.Body>
            <Tab.Content>
              <Tab.Pane eventKey="save-haven-demand" mountOnEnter unmountOnExit>
                <SaveHavenDemand />
              </Tab.Pane>
              <Tab.Pane eventKey="junk-bond-demand" mountOnEnter unmountOnExit>
                <h2>junk-bond-demand</h2>
              </Tab.Pane>
              <Tab.Pane eventKey="market-momentum" mountOnEnter unmountOnExit>
                <h2>market-momentum</h2>
              </Tab.Pane>
              <Tab.Pane
                eventKey="put-and-calls-options"
                mountOnEnter
                unmountOnExit
              >
                <h2>put-and-calls-options</h2>
              </Tab.Pane>
              <Tab.Pane
                eventKey="stock-price-breadth"
                mountOnEnter
                unmountOnExit
              >
                <h2>stock-price-breadth</h2>
              </Tab.Pane>
              <Tab.Pane
                eventKey="stock-price-strength"
                mountOnEnter
                unmountOnExit
              >
                <h2>stock-price-strength</h2>
              </Tab.Pane>
            </Tab.Content>
          </Card.Body>
        </Card>
      </Tab.Container> */}

      <Overtime />
    </div>
  );
}

FearGeed.propTypes = {
  windowSize: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(FearGeed);
